module.exports = __webpack_public_path__ + "img/pro_five_2.89971b92.jpg";